<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sun`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 3a1 1 0 00-1-1h-2a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1V3zm14.264 6.15l-1.415-1.413a1 1 0 00-1.414 0l-2.121 2.12a1 1 0 000 1.415l1.414 1.414a1 1 0 001.414 0l2.121-2.121a1 1 0 000-1.414zM38 24c0-7.732-6.268-14-14-14s-14 6.268-14 14 6.268 14 14 14 14-6.268 14-14zM12.686 36.728l-1.414-1.414a1 1 0 00-1.414 0l-2.121 2.121a1 1 0 000 1.414l1.414 1.415a1 1 0 001.414 0l2.121-2.122a1 1 0 000-1.414zM26 42a1 1 0 00-1-1h-2a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3zm12.142-6.686l2.121 2.121a1 1 0 010 1.414l-1.414 1.415a1 1 0 01-1.414 0l-2.121-2.122a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0zM24 14c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zM7 23a1 1 0 00-1-1H3a1 1 0 00-1 1v2a1 1 0 001 1h3a1 1 0 001-1v-2zm38-1a1 1 0 011 1v2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-2a1 1 0 011-1h3zM10.565 7.737l2.121 2.12a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.414 0l-2.121-2.121a1 1 0 010-1.414L9.15 7.737a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconSun',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
